import { clearLocalStorageExceptPersisted } from '@/utils/storage/persistedStorage';
import { auth } from '@/api/login';
import '@/assets/style/companyList.scss';
import { decryptData } from '@/components/reusable/crypto/Cipher';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import { globalSearch } from '@/utils/search/Search';
import { inventoryGroupTableHeader as columns } from '@/utils/tableHeader';
import { LogoutOutlined, MailFilled, SearchOutlined } from '@ant-design/icons';
import { Button, Card, Col, Flex, Input, Row, Table } from 'antd';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
/**
 * CompanyList component displays a table of company details.
 */
const CompanyList = () => {
  const navigate = useNavigate();
  // const [companyList, setCompanyList] = useState();
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTrem] = useState('');
  const firstList = Cookies.get('companyList')
    ? Cookies?.get('companyList')
    : [];

  const companyList = firstList?.length ? decryptData(firstList) : [];

  /**
   * Handles search input change.
   * @param {string} value - Search input value
   */
  const handleSearch = (value) => {
    setSearchTrem(value);
  };

  /**
   * Filters table data based on search term.
   */
  const filteredTableData = globalSearch(companyList, searchTerm);

  /**
   * Effect to fetch company list on component mount.
   */
  // useEffect(() => {
  //   const fetchCompanyList = async () => {
  //     try {
  //       setLoading(true);
  //       const response = await ShowAllData.showDetails(
  //         '/userwise/company/list/',
  //         navigate,
  //       );
  //       setCompanyList(response.data);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchCompanyList();
  // }, []);

  const Logout = async () => {
    await auth.logout();
    Cookies.remove('token');
    clearLocalStorageExceptPersisted();
    navigate('/login/');
  };

  useEffect(() => {
    if (!companyList.length) {
      // navigate('/dashboard/');
    }
  }, []);

  return (
    <div>
      <ToastContainer />
      <div className="table">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card
              variant="borderless"
              className="circlebox tablespace mb-24"
              title={
                <>
                  <Flex style={{ marginTop: '10px' }}>
                    <GlobalDivider name="Company List" />
                  </Flex>
                </>
              }
              extra={
                <Flex gap={10}>
                  <Button
                    onClick={() => Logout()}
                    style={{ padding: '15px' }}
                    icon={<LogoutOutlined />}
                  />
                  <Input
                    className="header-search"
                    placeholder="Search company..."
                    onChange={(e) => handleSearch(e.target.value)}
                    prefix={<SearchOutlined />}
                  />
                </Flex>
              }
            >
              <div className="table-responsive">
                <Table
                  size="medium"
                  bordered
                  columns={columns}
                  scroll={{ y: '68vh' }}
                  className="ant-border-space"
                  style={{ textAlign: 'center', padding: '15px' }}
                  pagination={false}
                  loading={loading}
                  dataSource={filteredTableData}
                  onRow={(record) => {
                    return {
                      onClick: async () => {
                        Cookies.set('companyCode', record.companyId, {
                          secure: false,
                          expires: 7,
                        });
                        navigate('/userwise/branch/list/');
                      },
                      style: { cursor: 'pointer' },
                    };
                  }}
                  footer={() => (
                    <div
                      style={{
                        float: 'left',
                        marginTop: '40px',
                        background: 'none',
                      }}
                    >
                      <Button
                        type="link"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                        }}
                      >
                        {' '}
                        <MailFilled />
                        Contact for Support
                      </Button>
                    </div>
                  )}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CompanyList;
